<table class="ir-plugin-table">
  <tr>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <span>
        <strong>{{ 'plugins.installationvoltage.datetime' | translate }}</strong>
      </span>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <span>
        <strong>
          {{ 'plugins.installationvoltage.L1L2' | translate }}
        </strong>
      </span>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <span>
        <strong>
          {{ 'plugins.installationvoltage.L1L3' | translate }}
        </strong>
      </span>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <span>
        <strong>
          {{ 'plugins.installationvoltage.L2L3' | translate }}
        </strong>
      </span>
    </td>
  </tr>
  <tr *ngFor="let voltage of voltages">
    <td class="th-plugin-line--subheader" style="width: 25%">
      <p>
        <span>{{ voltage.DateTime | formatDate }} - {{ voltage.DateTime | date: 'HH:mm' }}</span>
      </p>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <p>
        <span>{{ voltage.L1L2 }}</span>
      </p>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <p>
        <span>{{ voltage.L1L3 }}</span>
      </p>
    </td>
    <td class="th-plugin-line--subheader" style="width: 25%">
      <p>
        <span>{{ voltage.L2L3 }}</span>
      </p>
    </td>
  </tr>
</table>
